import { render, staticRenderFns } from "./MaliciousDomain.vue?vue&type=template&id=31af6698&scoped=true"
import script from "./MaliciousDomain.vue?vue&type=script&lang=js"
export * from "./MaliciousDomain.vue?vue&type=script&lang=js"
import style0 from "./MaliciousDomain.vue?vue&type=style&index=0&id=31af6698&prod&lang=less&scoped=true"
import style1 from "./MaliciousDomain.vue?vue&type=style&index=1&id=31af6698&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af6698",
  null
  
)

export default component.exports